import React, { useCallback, useContext, useEffect, useState } from 'react';
import { CloseSquareOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import { debounce } from '@totem/utilities/debounce';

const DEBOUNCE_TIME = 300;

const DeviceSearch = () => {
  const { handleFilter, getFilterValue, isReady } = useContext(InputContext);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [searchIpAddress, setSearchIpAddress] = useState<string>('');
  const [searchKey, setSearchKey] = useState<string>('');

  // Once persistence has loaded and been applied, sync the input display values
  // from the context so restored filter values appear in the text boxes.
  useEffect(() => {
    if (isReady) {
      setSearchTerm(getFilterValue('searchTerm'));

      setSearchIpAddress(getFilterValue('searchIpAddress'));

      setSearchKey(getFilterValue('searchKey'));
    }
  }, [isReady]);

  const sendDeviceSearch = useCallback(
    debounce(
      (newSearchTerm: string) => handleFilter('searchTerm', newSearchTerm),
      DEBOUNCE_TIME,
    ),
    [],
  );

  const sendIpAddressSearch = useCallback(
    debounce(
      (newSearchTerm: string) => handleFilter('searchIpAddress', newSearchTerm),
      DEBOUNCE_TIME,
    ),
    [],
  );

  const sendKeySearch = useCallback(
    debounce(
      (newSearchTerm: string) => handleFilter('searchKey', newSearchTerm),
      DEBOUNCE_TIME,
    ),
    [],
  );

  const handleDeviceSearch = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);

    sendDeviceSearch(newSearchTerm);
  };

  const handleIPAddressSearch = (newSearchTerm: string) => {
    setSearchIpAddress(newSearchTerm);

    sendIpAddressSearch(newSearchTerm);
  };

  const handleKeySearch = (newSearchTerm: string) => {
    setSearchKey(newSearchTerm);

    sendKeySearch(newSearchTerm);
  };

  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td style={{ width: '300px' }}>
            <b>Device Name:</b>&nbsp;
            <Input
              placeholder="Device Search"
              value={searchTerm}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                handleDeviceSearch(evt.target.value ?? '')
              }
            />
          </td>
          <td>
            <br />
            <CloseSquareOutlined onClick={() => handleDeviceSearch('')} />
          </td>
          <td style={{ width: '300px' }}>
            <b>Device IP Address:</b>&nbsp;
            <Input
              placeholder="Search IP Address"
              value={searchIpAddress}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                handleIPAddressSearch(evt.target.value ?? '')
              }
            />
          </td>
          <td>
            <br />
            <CloseSquareOutlined onClick={() => handleIPAddressSearch('')} />
          </td>
          <td style={{ width: '300px' }}>
            <b>MAC Address / Key:</b>&nbsp;
            <Input
              placeholder="Search MAC Address / Key"
              value={searchKey}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                handleKeySearch(evt.target.value ?? '')
              }
            />
          </td>
          <td>
            <br />
            <CloseSquareOutlined onClick={() => handleKeySearch('')} />
          </td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  );
};

export default DeviceSearch;
